/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddCountryManagerRequest
 */
export interface AddCountryManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof AddCountryManagerRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddCountryManagerRequest
     */
    managerId: string;
}

/**
 * Check if a given object implements the AddCountryManagerRequest interface.
 */
export function instanceOfAddCountryManagerRequest(value: object): value is AddCountryManagerRequest {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('managerId' in value) || value['managerId'] === undefined) return false;
    return true;
}

export function AddCountryManagerRequestFromJSON(json: any): AddCountryManagerRequest {
    return AddCountryManagerRequestFromJSONTyped(json, false);
}

export function AddCountryManagerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCountryManagerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'managerId': json['managerId'],
    };
}

export function AddCountryManagerRequestToJSON(value?: AddCountryManagerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
        'managerId': value['managerId'],
    };
}

